import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { EMaterielEauPonctuel } from 'src/app/domain/Lac - EAU/enum/materiel-eau-ponctuel';
import { PrelevementLac } from 'src/app/domain/Lac - EAU/prelevement-lac';
import { StringConverter } from '../string-converter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-lac-pontuel-dialog-box',
    templateUrl: './lac-pontuel-dialog.component.html',
    styleUrls: ['./lac-pontuel-dialog.component.scss']
})
export class LacPonctuelDialogomponent implements OnInit {
    EMaterielEauPonctuel = EMaterielEauPonctuel;
    public PMAX = 150; // m
    ValidProfMax = new UntypedFormControl(0, [Validators.max(this.PMAX), Validators.min(0)]);
    public MaterielPonctuelList: string[] = Object.values(EMaterielEauPonctuel).filter(x => !isNaN(Number(x))).map(x => StringConverter.getMaterielEauPonctuelName(x as EMaterielEauPonctuel));
    public NewPrelevement: PrelevementLac = new PrelevementLac();

    constructor(
        private dialogRef: MatDialogRef<LacPonctuelDialogomponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.NewPrelevement = data ?? new PrelevementLac();
    }

    ngOnInit(): void {
        this.ValidProfMax.markAsTouched();
    }

    CanAddNewMeasure() {
        return this.NewPrelevement.Profondeur && this.NewPrelevement.TemperatureGlaciere && this.NewPrelevement.NbFlacon
            && (this.NewPrelevement.Materiel === EMaterielEauPonctuel.Manuel || (this.NewPrelevement.Materiel !== EMaterielEauPonctuel.Manuel && this.NewPrelevement.ReferenceMateriel)) 
            && this.ValidProfMax.valid;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.NewPrelevement);
    }
}
